// Preset kudos (owner 2026-10-07). Presets only, so nothing needs moderating.
// Keys and text mirror public.kudos_message(); the server decides what a
// kudos says, the client only sends the key.
export const KUDOS = [
  { key: 'nice_job', emoji: '👏', text: 'Nice job!' },
  { key: 'well_done', emoji: '🙌', text: 'Well done!' },
  { key: 'great_picks', emoji: '🎯', text: 'Great picks!' },
  { key: 'got_me', emoji: '😤', text: 'You got me this time!' },
  { key: 'got_the_dub', emoji: '🏆', text: 'Way to get the dub!' },
]
